import { render, staticRenderFns } from "./PartnerEntityFormatter.vue?vue&type=template&id=91546704&"
import script from "./PartnerEntityFormatter.vue?vue&type=script&lang=js&"
export * from "./PartnerEntityFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports